export default ngModule => {

    ngModule.controller('PriceSummaryCtrl', function (AonApi, $state, $stateParams) {

        const {priceId} = $stateParams;

        this.priceId = priceId;
        this.applicant = JSON.parse(window.localStorage.getItem('price-summary-application') || '{}');
        this.loading = true;
        this.error = false;

        if (!Object.keys(this.applicant)) {
            this.error = 'Unable to retrieve applicant data from local storage';
        }
        if (!priceId) {
            this.error = 'No price id supplied';
        }

        this.value = (val, prefix, suffix) => {
            return (val === undefined || val === null) ? '' : `${prefix}${val}${suffix}`
        }

        AonApi.fetchPrice(this.applicant, priceId)
            .then(({data: pkg}) => {
                this.price = pkg.price;
                const priceField = 'monthly_adjusted_price_dd_discount';
                this.current = (this.price.pricing.available || {})[priceField];
                this.future = (this.price.pricing.future || {})[priceField];
                // Some fields can be extracted from either price struct (discounts tho??)
                const {lhc_percent, rebate_percent} = this.current || this.future || {};
                this.lhc_percent = lhc_percent.toFixed(2);
                this.rebate_percent = rebate_percent.toFixed(3);
                this.loading = false;
            }).catch((error) => {
            this.error = error;
            this.loading = false;
        });
    });

};


// WEBPACK FOOTER //
// ./src/controllers/comparator/price-summary-ctrl.js